import { Injectable } from '@angular/core';

import { MatDialog, MatDialogRef } from '@angular/material/dialog';

@Injectable({
  providedIn: 'root',
})
export class ModalDialogService {
  $dialogRef: MatDialogRef<any>;

  constructor(public dialog: MatDialog) {}

  open(options, component) {
    // const dialogRef = this.dialog.open(component, {
    this.$dialogRef = this.dialog.open(component, {
      width: options.width || '450px',
      minHeight: options.minHeight || '',
      maxHeight: options.minHeight || '',
      panelClass: options.panelClass || '',
      position: options.position || '',
      disableClose: options.disableClose || false,
      data: {
        title: options.data.title || '',
        obj: options.data.obj || null,
        params: options.data.params || '',
      },
    });

    if (options.preventCloseOnSave) {
      this.$dialogRef.componentInstance.dialogSaved.subscribe((result) => {
        // console.log('dialogSaved', result);

        if (result && options.confirmCallback) {
          options.confirmCallback(result);
        }

        // const ref =
        // ref.unsubscribe(); // needed ?
      });
    }
    // } else {
    this.$dialogRef.afterClosed().subscribe((result) => {
      if (result && options.confirmCallback) {
        options.confirmCallback(result);
      }
    });
    // }

    // const sub = dialogRef.componentInstance.onAdd.subscribe((data) => {
    //   alert(data);
    // });
  }
}

// import { TranslateService } from '@ngx-translate/core';
// , private translateService: TranslateService

// data = {};
// data: this.data,
// this.translateService.get(['']).subscribe(() => {
//   this.data = {
//     title: this.translateService.instant(options.data.title),
//     confirmText: options.data.confirmText
//       ? this.translateService.instant(options.data.confirmText)
//       : 'Confirm',
//     cancelText: options.data.cancelText
//       ? this.translateService.instant(options.data.cancelText)
//       : 'Cancel',
//     obj: options.data.obj,
//     params: options.data.params,
//   };
// });

// confirmText: options.data.confirmText || 'CONFIRM',
// cancelText: options.data.cancelText || 'CANCEL',

// data: {
//   title: options.title || '',
//   confirmText: options.confirmText || 'Confirm',
//   cancelText: options.cancelText || 'Cancel',
//   obj: options.obj,
//   params: options.params,
// },
